import type { Transformer } from "@/Common/Models/Domain/Transformer";
import type { TherapistLevel, TherapistLevelGoal } from "@/Modules/Models/Domain/Therapist";
import type { TherapistLevelUi, TherapistLevelGoalUi, TherapistLevelAvatarUi } from "../Models/Ui/Therapist";

class TherapistLevelToTherapistLevelUiTransformer implements Transformer<TherapistLevel, TherapistLevelUi> {
  public transform(therapistLevel: TherapistLevel): TherapistLevelUi {
    const therapistLevelGoalsUi = this.transformTherapistLevelGoalToTherapistLevelGoalUi(
      therapistLevel.goals
    );

    const therapistLevelUi: TherapistLevelUi = {
      goals: therapistLevelGoalsUi,
      maxLevel: therapistLevel.maxLevel,
      value: therapistLevel.level,
      avatar: this.computeTherapistLevelAvatarUi(therapistLevel),
    };

    return therapistLevelUi;
  }

  private computeTherapistLevelAvatarUi(therapistLevel: TherapistLevel): TherapistLevelAvatarUi {
    const therapistLevelAvatarsUi: TherapistLevelAvatarUi[] = [
      { name: "Klein", image: "klein" },
      { name: "Watson", image: "watson" },
      { name: "Ellis", image: "ellis" },
    ];

    return therapistLevelAvatarsUi[therapistLevel.level - 2]!;
  }

  private transformTherapistLevelGoalToTherapistLevelGoalUi(
    therapistLevelGoals: TherapistLevelGoal[]
  ): TherapistLevelGoalUi[] {
    const therapistLevelGoalsUi = therapistLevelGoals.map((therapistLevelGoal) => {
      const therapistLevelGoalUi: TherapistLevelGoalUi = {
        i18n: therapistLevelGoal.i18n,
        max: therapistLevelGoal.max,
        percentage: therapistLevelGoal.percentage,
        value: therapistLevelGoal.value,
      };

      return therapistLevelGoalUi;
    });

    return therapistLevelGoalsUi;
  }
}

export default TherapistLevelToTherapistLevelUiTransformer;
